import { makeStyles } from "@mui/styles";

const viewerContentStyle = makeStyles((theme) => ({

    ifcContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        width: "100%",
        height: "76.5vh",
        overflow: "hidden",
        [theme.breakpoints.down('sm')]: {
            height: "75vh",
        },
    },
    fullscreenButton: {
        position: "absolute !important",
        top: "1.5rem",
        right: "1.5rem",
        color: "#e6e6e6 !important",
        fontSize: '10rem !important',
        zIndex: 100,
        '&:hover': {
            transform: "scale(1.2)",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
    },
    vcContainer:{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        maxwidth: "1200px",
        Margin: "0 auto",
        boxSizing: "border-box" ,
        position: "relative",
    },
    vcStyle: {
        width: "100%",
        height: "76.5vh",
        border: "1px solid #ccc",
        borderRadius: "8px",
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            height: "75vh",
        },
    },
    fullscreenButtonVc: {
        position: "absolute !important",
        top: "0.2rem",
        right: "10rem",
        color: "#000000 !important",
        zIndex: 100,
        paddingRight: "3px",
        paddingLeft: "3px",
        transition: "background-color 0.3s ease, transform 0.3s ease",
        '& svg': {
            fontSize: "1.8rem !important",
        },
        '&:hover': {
            backgroundColor: "#c2c0c0!important",
            borderRadius: "8px",

        },
        [theme.breakpoints.down("sm")]: {
            bottom: "0.32rem",  // Move to bottom
            right: "1rem", // Align to the right corner
            top: "unset", // Remove the top positioning
            '& svg': {
                fontSize: "3rem !important",
            },
            '&:hover': {
            backgroundColor: "#464646!important",
            borderRadius: "4px",
        },
        },
    },

}));

export default viewerContentStyle;
